import ForgotPassword from './forgot_password';

export default ForgotPassword;
